// extracted by mini-css-extract-plugin
export default {"header":"ConsumptionView_header__qdBig","chartContainer":"ConsumptionView_chartContainer__eVmEj"};